import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { reviewsData } from '../data/menuData';
import { Star, Quote } from 'lucide-react';

export default function ReviewsSection() {
  const { language, t } = useLanguage();

  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="section-padding bg-[#2A1E17]"
    >
      <div className="section-container">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#8C5A2B] mb-4">
            {t('reviews.overline')}
          </p>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-medium text-[#FBF9F6]">
            {t('reviews.title')}
          </h2>
          <div className="w-20 h-[2px] bg-[#8C5A2B] mx-auto mt-6" />
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviewsData.map((review, index) => (
            <div
              key={index}
              data-testid={`review-${index}`}
              className="bg-[#3A2E27] p-8 relative"
            >
              {/* Quote Icon */}
              <Quote
                size={32}
                className="text-[#8C5A2B]/30 absolute top-6 right-6"
                strokeWidth={1}
              />

              {/* Rating */}
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    size={16}
                    fill={i < review.rating ? '#8C5A2B' : 'none'}
                    stroke={i < review.rating ? '#8C5A2B' : '#6B584B'}
                    strokeWidth={1.5}
                  />
                ))}
              </div>

              {/* Review Text */}
              <p className="text-[#E6D8C8] text-sm leading-relaxed mb-6">
                "{review.text[language]}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-[#8C5A2B] rounded-full flex items-center justify-center">
                  <span className="text-[#FBF9F6] font-medium text-sm">
                    {review.name.charAt(0)}
                  </span>
                </div>
                <span className="text-[#FBF9F6] font-medium text-sm">
                  {review.name}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
